export default __webpack_public_path__ + "static/media/SILVERBACK-LOGO.03418958.png";